import { render, staticRenderFns } from "./AlertPreferenceDialog.vue?vue&type=template&id=3635aa4e&"
import script from "./AlertPreferenceDialog.vue?vue&type=script&lang=js&"
export * from "./AlertPreferenceDialog.vue?vue&type=script&lang=js&"
import style0 from "./AlertPreferenceDialog.vue?vue&type=style&index=0&id=3635aa4e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports